(function () {
  function buildRow() {
    var wrapper = document.querySelector('.product__info-wrapper');
    if (!wrapper) return true;
    var stars = wrapper.querySelector('.areviews_header_stars');
    var skuText = wrapper.querySelector('.product__meta.product__sku');
    if (!stars || !skuText) return true;
    if (stars.parentElement && stars.parentElement.classList.contains('pdp-reviews-sku-row')) {
      return true;
    }
    var skuContainer = skuText.closest('.copy-text') || skuText;
    var metaBlock = skuContainer.closest('.product__block--meta');

    var row = document.createElement('div');
    row.className = 'pdp-reviews-sku-row';
    stars.parentNode.insertBefore(row, stars);
    row.appendChild(stars);
    row.appendChild(skuContainer);

    if (metaBlock && !metaBlock.querySelector('.product__meta')) {
      metaBlock.classList.add('pdp-meta-empty');
    }
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildRow);
  } else {
    buildRow();
  }
})();
